import { snackBarOverrides } from '@/shared/components/SnackBar/styled-components'

export const SNACKBAR_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
}

export const showSnackbar = (enqueue, options) => {
  const { type = SNACKBAR_TYPES.SUCCESS, message = null, ...rest } = options

  if (!message) {
    return
  }

  enqueue({
    message,
    overrides: snackBarOverrides(type),
    autoHideDuration: 15000,
    ...rest,
  })
}
